function getVenueUrls(venue, type) {
  const key = type + '_urls';
  if (!venue || !Array.isArray(venue[key])) return [];
  return venue[key].filter((item) => item.url);
}

// Dynamic link click handler
document.addEventListener('click', (e) => {
  const anchor = e.target.closest('a');
  if (!anchor || !anchor.hash) return;

  const venue = get_current_venue_info();
  if (!venue) return;

  if (anchor.hash === '#link-takeout') {
    e.preventDefault();
    e.stopPropagation();

    const urls = getVenueUrls(venue, 'takeout');
    if (urls.length === 1) {
      window.open(urls[0].url, '_blank', 'noopener');
    } else if (urls.length > 1) {
      window.location.hash = 'modal-order-takeout';
    }
  } else if (anchor.hash === '#link-delivery') {
    e.preventDefault();
    e.stopPropagation();

    const urls = getVenueUrls(venue, 'delivery');
    if (urls.length === 1) {
      window.open(urls[0].url, '_blank', 'noopener');
    } else if (urls.length > 1) {
      window.location.hash = 'modal-order-delivery';
    }
  }
});

// Dynamic link replacement (for visual updates)
const updateLinks = () => {
  const venue = get_current_venue_info();
  if (!venue) return;

  const takeoutUrls = getVenueUrls(venue, 'takeout');
  const deliveryUrls = getVenueUrls(venue, 'delivery');

  document.querySelectorAll('.link-takeout-replaced, a[href="#link-takeout"]').forEach((link) => {
    if (takeoutUrls.length > 0) {
      if (takeoutUrls.length === 1) {
        link.href = takeoutUrls[0].url;
        link.target = '_blank';
      } else {
        link.href = '#link-takeout';
        link.removeAttribute('target');
      }
      link.classList.add('link-takeout-replaced');
      link.classList.remove('hidden!');
    } else {
      link.href = '#';
      link.classList.add('link-takeout-replaced');
      link.classList.add('hidden!');
    }
  });

  document.querySelectorAll('.link-delivery-replaced, a[href="#link-delivery"]').forEach((link) => {
    if (deliveryUrls.length > 0) {
      if (deliveryUrls.length === 1) {
        link.href = deliveryUrls[0].url;
        link.target = '_blank';
      } else {
        link.href = '#link-delivery';
        link.removeAttribute('target');
      }
      link.classList.add('link-delivery-replaced');
      link.classList.remove('hidden!');
    } else {
      link.href = '#';
      link.classList.add('link-delivery-replaced');
      link.classList.add('hidden!');
    }
  });
}

updateLinks();
document.body.addEventListener('venueChanged', updateLinks);
